import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import {
    StateType,
    replaceHistoryState,
    hasAccess,
} from "client/utils"
import { markovModelsRoute } from "client/parts/routes"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovModelProps,
    LoadMarkovModelById,
    setMarkovModelView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"

import StateList from "client/pages/markov/state/list"
import GroupList from "client/pages/markov/group/list"
import DatasetList from "client/pages/markov/dataset"
import TransitionList from "client/pages/markov/transition/list"
import StartvectorList from "client/pages/markov/startvector"
import RedistributionList from "client/pages/markov/redistribution"
import Form from "./form"


const MODEL = "#model"
const CALCULATIONS = "#calculations"
const RESULTS = "#results"
const ACTIONS = "#actions"

const menu = [MODEL, CALCULATIONS, RESULTS, ACTIONS]

const View = ({
    modelId = null,
    hash = null,
}: MarkovModelProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)
    const reloadView = useSelector((state: StoreType) => state.markovModel.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [activeTab, setActiveTab] = useState(menu.includes(hash) ? hash : MODEL)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadMarkovModelById(modelId, userData.accountId)
        .then((res) => {
            dispatch(setMarkovModelView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const handleMenuClick = (tab: string) => {
        setActiveTab(tab)
        replaceHistoryState(`${markovModelsRoute}/${VIEW}/${modelId}${tab}`)
    }

    const viewAccess = hasAccess(PRM_MARKOV_MODEL, VIEW)

    if (!viewAccess) return <AccessDenied />
    if (!model) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewModel} # ${model.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageMenu>
                    <PageMenuButton
                        isActive={activeTab === MODEL}
                        onClick={() => handleMenuClick(MODEL)}
                    >
                        {lang.model}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={activeTab === CALCULATIONS}
                        onClick={() => handleMenuClick(CALCULATIONS)}
                    >
                        {lang.calculations}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={activeTab === RESULTS}
                        onClick={() => handleMenuClick(RESULTS)}
                    >
                        {lang.results}
                    </PageMenuButton>
                    <PageMenuButton
                        isActive={activeTab === ACTIONS}
                        onClick={() => handleMenuClick(ACTIONS)}
                    >
                        {lang.actions}
                    </PageMenuButton>
                </PageMenu>
                <Tab show={activeTab === MODEL}>
                    {loadState === PENDING && <Loader />}
                    <Form />
                    <StateList />
                    <GroupList />
                    <DatasetList />
                    <TransitionList />
                    <StartvectorList />
                    <RedistributionList />
                </Tab>
                <Tab show={activeTab === CALCULATIONS}>
                    CALCULATIONS
                </Tab>
                <Tab show={activeTab === RESULTS}>
                    RESULTS
                </Tab>
                <Tab show={activeTab === ACTIONS}>
                    ACTIONS
                </Tab>
            </PageContent>
        </Container>
    )
}
export default View
